import type { IContractToRegistration } from '@klp/contractregistration/classes';
import type { Theme } from '@material-ui/core';

export const getStyles = () => {
    const styles = (theme: Theme) => ({
        centerText: {
            textAlign: 'center',
        },
        download: {
            textAlign: 'left',
            '& > *': {
                display: 'inline-block',
                '& > *': {
                    margin: theme.spacing(1),
                },
            },
        },
        previewDownload: {
            cursor: 'pointer',
        },
        table: {
            cursor: 'pointer',
        },
        tableBlurred: {
            // Elements, since MUI's class names get a generated suffix in this app
            '& tbody tr': {
                opacity: 0.4,
                filter: 'blur(1px)',
                pointerEvents: 'none',
                transition: 'opacity 0.2s, filter 0.2s, background-color 0.2s',
            },
            '& tbody tr[data-active="true"]': {
                opacity: 1,
                filter: 'none',
                pointerEvents: 'auto',
                backgroundColor: theme.palette.secondary.veryLight,
            },
        },
    });

    return styles;
};

export const getContractAnsvarligName = (line: IContractToRegistration) => {
    return (
        (line.prosessForvalterNavn ||
            line.ansvarlig?.navn ||
            line.bygg?.forvalterNavn) ??
        null
    );
};

export const getContractAnsvarligOekonomiName = (
    line: IContractToRegistration,
) => {
    return (line.prosessOekonomiNavn || line.bygg?.oekonomiNavn) ?? null;
};
